export class GoldenShelf {
	private static readonly _min: number = 0.8;
	private static readonly _max: number = 1.75;

	public static get min(): number {
		return this._min;
	}

	public static get max(): number {
		return this._max;
	}

	public static isPointOn(y: number): boolean {
		return !(y < this._min || y > this._max);
	}
}